import { render, staticRenderFns } from "./dyt-upload.vue?vue&type=template&id=2b5ae5bc&"
import script from "./dyt-upload.vue?vue&type=script&lang=js&"
export * from "./dyt-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports